import { useState } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { createCheckoutSession, StripePlan } from '@/services/stripeService';
import { toast } from 'sonner';

type UpgradeOption = 'basic' | 'pro';

interface QuotaUpgradeModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  options?: UpgradeOption[];
}

const PLAN_CONFIG: Record<UpgradeOption, { label: string; detail: string; plan: StripePlan }> = {
  basic: {
    label: 'Contratar Básico',
    detail: 'Tests tipo test, flashcards y chat tutor en tu oposición elegida',
    plan: 'oposiciones_basic_monthly',
  },
  pro: {
    label: 'Contratar Pro',
    detail: 'Materiales PDF, supuestos prácticos y simulador oral',
    plan: 'oposiciones_single_monthly',
  },
};

export function QuotaUpgradeModal({ open, onOpenChange, title, description, options = ['basic', 'pro'] }: QuotaUpgradeModalProps) {
  const [loading, setLoading] = useState<UpgradeOption | null>(null);

  const handleUpgrade = async (option: UpgradeOption) => {
    try {
      setLoading(option);
      const url = await createCheckoutSession(PLAN_CONFIG[option].plan);
      window.open(url, '_blank', 'noopener,noreferrer');
      onOpenChange(false);
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'No se pudo iniciar el pago');
    } finally {
      setLoading(null);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <div className="space-y-2">
          <h2 className="text-xl font-bold">{title}</h2>
          <p className="text-sm text-muted-foreground">{description}</p>
          <p className="text-xs text-muted-foreground">Tu cuota se renueva automáticamente el día 1 del próximo mes.</p>
        </div>
        <div className="space-y-3 pt-2">
          {options.map((option) => (
            <Button key={option} variant={option === 'pro' ? 'default' : 'outline'} className="w-full h-auto justify-between py-3 text-left" onClick={() => handleUpgrade(option)} disabled={loading !== null}>
              <span>
                <span className="block font-semibold">{PLAN_CONFIG[option].label}</span>
                <span className="block text-xs font-normal opacity-80">{PLAN_CONFIG[option].detail}</span>
              </span>
              {loading === option && <span className="text-xs">Cargando...</span>}
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
